<template>
    <gz-auth-view-template>
        <section slot="content" class="jg-certificate__container">        
            <section class="jg-certificate__form">
                <gz-input-container
                    label="Нас. пункт"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.location">
                </gz-input-container>
                
                <gz-input-container
                    label="Дата"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.date.d" placeholder="число">
                    <input type="text" class="gz-text-input" v-model="form.date.m" placeholder="месяц">
                    <input type="text" class="gz-text-input" v-model="form.date.y" placeholder="год">
                </gz-input-container>
                
                <gz-input-container
                    label="Номер дома"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.address.building">
                </gz-input-container>
                
                <gz-input-container
                    label="Улица"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.address.street">
                </gz-input-container>
                
                <gz-input-container
                    label="Кол-во квартир"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.address.count">
                </gz-input-container>
                
                <gz-input-container
                    label="Обособленный дымоходный канал шт."
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.dkCount">
                </gz-input-container>
                
                <gz-input-container
                    label="Обособленные вентиляционный каналы шт."
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.vkCount">
                </gz-input-container>
                
                <gz-input-container
                    label="Квартиры"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.propertyNumber">
                </gz-input-container>
                
                <gz-input-container
                    label="Сечение дымоходный канал"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.dkMm">
                </gz-input-container>
                
                <gz-input-container
                    label="Сечение вентиляционный канал"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.vkMm">
                </gz-input-container>
                
                <gz-input-container
                    label="Материалы дымоходных каналов"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.dkMaterial">
                </gz-input-container>
               
                <gz-input-container
                    label="Материалы вентиляционных каналов"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.vkMaterial">
                </gz-input-container>
                
                <gz-input-container
                    label="Противопожарные разделки составляют"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.razdelki">
                </gz-input-container>
                
                <gz-input-container
                    label="Разряжение воздуха в дымоходе составляет"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.razryazhenie">
                </gz-input-container>
                
                <gz-input-container
                    label="Прибор для проверки"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.checkingDevice">
                </gz-input-container>
                
                <gz-input-container
                    label="Нормальная тяга на день проверки ДВК"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.tyaga">
                </gz-input-container>
                
                <gz-input-container
                    label="Несмываемая краска"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.paint">
                </gz-input-container>
                
                <gz-input-container
                    label="Количество удаляемого воздуха (2-к, 3-к, 4-к)"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.removeAirFor2" placeholder="2-комф. плита">
                    <input type="text" class="gz-text-input" v-model="form.removeAirFor3" placeholder="3-комф. плита">
                    <input type="text" class="gz-text-input" v-model="form.removeAirFor4" placeholder="4-комф. плита">
                </gz-input-container>
                
                <gz-input-container
                    label="Дифманометр"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.difmanometr">
                </gz-input-container>
                
                <gz-input-container
                    label="Дифманометр испытан"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.difmanometrTestingDate">
                </gz-input-container>
                
                <gz-input-container
                    label="Заключение п.2. Каналы в кв. ... "
                    class="gz-input-container_default"
                >
                    <textarea type="text" class="gz-text-input" v-model="form.conclusion.empty2_1" style="height: 100px"></textarea>
                </gz-input-container>
                
                <gz-input-container
                    label="Заключение п.2. ...не могут быть допущены в эксплуатацию по причине... "
                    class="gz-input-container_default"
                >
                    <textarea type="text" class="gz-text-input" v-model="form.conclusion.empty2_2" style="height: 100px"></textarea>
                </gz-input-container>
                
                <gz-input-container
                    label="Заключение п.2. ...и эксплуатация газовых приборов... "
                    class="gz-input-container_default"
                >
                    <textarea type="text" class="gz-text-input" v-model="form.conclusion.empty2_3" style="height: 100px"></textarea>
                </gz-input-container>
                
                <gz-input-container
                    label="Заключение п.3"
                    class="gz-input-container_default"
                >
                    <textarea class="gz-text-input" v-model="form.conclusion.empty3" style="height: 100px"></textarea>
                </gz-input-container>
                
                <gz-input-container
                    label="Собственник"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.footer.ownerName">
                </gz-input-container>
                
                <gz-input-container
                    label="Мастер"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.footer.masterName">
                </gz-input-container>
               
                <gz-input-container
                    label="Печник трубочист"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.footer.pechnikName">
                </gz-input-container>
               
                <gz-input-container
                    label="Акт зарегистрирован под №"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.footer.actNumber">
                </gz-input-container>
                
                <gz-input-container
                    label="Срок действия  акта до"
                    class="gz-input-container_default"
                >
                    <input type="text" class="gz-text-input" v-model="form.footer.actExpiringDate.d">
                    <input type="text" class="gz-text-input" v-model="form.footer.actExpiringDate.m">
                    <input type="text" class="gz-text-input" v-model="form.footer.actExpiringDate.y">
                </gz-input-container>
            </section>
            
            <section class="jg-certificate">
                <section ref="document">
                    <section class="jg-certificate__header">
                        <p class="jg-certificate__title">АКТ</p>
                        <p class="jg-certificate__subtitle">Первичной (периодической)  приёмки, проверки  дымовых и вентиляционных каналов</p>
                    </section>

                    <section class="jg-certificate__subheader">
                        <div class="jg-certificate__location">
                            <span>г.</span>
                            <span class="jg-certificate__location__name">{{ form.location }}</span>
                        </div>
                        <div class="jg-certificate__date">
                            <!-- <span>&#171; 21 &#187;</span>&nbsp; -->
                            <span>{{ form.date.d }} /</span>&nbsp;
                            <span>{{ form.date.m }} /</span>&nbsp;
                            <span><nobr>{{ form.date.y }} г.</nobr></span>
                        </div>
                    </section>

                    <section class="jg-certificate__content">
                        <p style="text-indent: 20px">Составлен в том, что при проверке технического состояния дымовых и вентиляционных каналов 
                            (колонок, плит, котлов и др.) с целью определения их пригодности для отвода продуктов 
                            сгорания и естественной  вентиляции при сжигании газа  в жилом доме</p>
                        <section class="jg-certificate__content__address">
                            <div class="jg-certificate__content__address__item">
                                <span>№</span>
                                <div><span>{{ form.address.building }}</span></div>
                                <span>по</span>
                            </div>
                            
                            <div class="jg-certificate__content__address__item">
                                <span>ул.</span>
                                <div><span>{{ form.address.street }}</span></div>
                            </div>

                            <div class="jg-certificate__content__address__item">
                                <span>на</span>
                                <div><span>{{ form.address.count }}</span></div>
                                <span>квартир.</span>
                            </div>
                        </section>

                        <section class="jg-certificate__content__info ">
                            <div class="jg-certificate__content__title"><span>Установлено:</span></div>

                            <div class="jg-certificate__content__item">
                                <p>1. Обособленный дымоходный канал общее количество <strong>{{ form.dkCount }}</strong> шт.</p>
                                <p>Обособленные вентиляционный каналы общее количество <strong>{{ form.vkCount }}</strong> шт.</p>
                                <p>имеются в кв. <strong>{{ form.propertyNumber }}</strong></p>
                                <p>а их сечение  составляет:</p>
                                <p>дымоходный канал <strong>{{ form.dkMm }}</strong> мм,</p>
                                <p>вентиляционный канал <strong>{{ form.vkMm }}</strong> мм,</p>
                            </div>
                            
                            <div class="jg-certificate__content__item">
                                <p>2. Каналы, включая оголовки, выполнены из:</p>
                                <p>дымоходный канал <strong>{{ form.dkMaterial }}</strong>,</p>
                                <p>вентиляционный канал <strong>{{ form.vkMaterial }}</strong></p>
                            </div>
                            
                            <div class="jg-certificate__content__item">
                                <p>3. Противопожарные  разделки составляют <strong>{{ form.razdelki }}</strong> мм.</p>
                            </div>
                            
                            <div class="jg-certificate__content__item">
                                <p>4. Все отверстия в  каналах, кроме отверстий для присоединения вытяжных труб от газовых приборов, вентиляционных решеток, заделаны.</p>
                            </div>

                            <div class="jg-certificate__content__item">
                                <p>5. Дымовые каналы <strong>{{ form.dkCount }}</strong> шт. имеют в нижней части «карманы» и люки для очистки.</p>
                            </div>
                            
                            <div class="jg-certificate__content__item">
                                <p>6. Оголовки  дымовых и вентиляционных  каналов не находятся в зоне ветрового подбора и в исправном состоянии, 
                                расстояние от конька и высота оголовка соответствует техническим условиям.</p>
                            </div>
                            
                            <div class="jg-certificate__content__item">
                                <p>7. Все каналы в кв. <strong>{{ form.propertyNumber }}</strong> очищены от сажи, 
                                посторонних предметов, строительного мусора и проверенны на герметичность, обособленность.</p>
                            </div>
                            
                            <div class="html2pdf__page-break"/>

                            <div class="jg-certificate__content__item">
                                <p>8. Разряжение воздуха в дымоходе составляет <strong>{{ form.razryazhenie }}</strong> Па.</p>
                                <p>Проверено прибором № <strong>{{ form.checkingDevice }}</strong></p>
                            </div>

                            <div class="jg-certificate__content__item">
                                <p>9. Нормальная тяга на день проверки ДВК {{ form.tyaga }}</p>
                            </div>
                            
                            <div class="jg-certificate__content__item">
                                <p>10. Все каналы на чердаке и крыше имеют нумерацию квартир, 
                                    нанесенную несмываемой краской {{ form.paint }}</p>
                            </div>
                            
                            <div class="jg-certificate__content__item">
                                <p>11. Количество удаляемого воздуха из помещений кухонь составляет:</p>
                                <p><strong>{{ form.removeAirFor2 }}%</strong> м<sup>3</sup>.час для 2-комф. плиты</p>
                                <p><strong>{{ form.removeAirFor3 }}%</strong> м<sup>3</sup>.час для 3-комф. плиты</p>
                                <p><strong>{{ form.removeAirFor4 }}%</strong> м<sup>3</sup>.час для 4-комф. плиты</p>
                                <p>все расчеты произведены  дифманометром № <strong>{{ form.difmanometr }}</strong>, 
                                испытан <strong>{{ form.difmanometrTestingDate }}</strong> кратность воздуха равна 3-м.</p>
                            </div>
                            
                            <div class="jg-certificate__content__title"><span>Заключение:</span></div>

                            <div class="jg-certificate__content__item">
                                <p>1. Обособленный дымоходный канал <strong>{{ form.dkCount }}</strong> шт.</p>
                                <p>Обособленные вентиляционный каналы <strong>{{ form.vkCount }}</strong> шт.</p>
                                <p>в кв. <strong>{{ form.propertyNumber }}</strong>, отвечают техническим условиям и пригодны для отвода продуктов сгорания от бытовых газовых приборов</p>
                            </div>
                            
                            <div class="jg-certificate__content__item">
                                <p>2. Каналы в кв. {{ form.conclusion.empty2_1 }} не пригодны и не могут быть допущены в эксплуатацию 
                                    по причине {{ form.conclusion.empty2_2 }}, и эксплуатация газовых приборов {{ form.conclusion.empty2_3 }} запрещается 
                                    до устранения выявленных недостатков.</p>
                            </div>
                            
                            <div class="jg-certificate__content__item">
                                <p>3. В кв. {{ form.conclusion.empty3 }} требуется выполнить ремонт оголовков.</p>
                            </div>
                        </section>

                        <section class="jg-certificate__footer ">
                            <div class="jg-certificate__footer__item">
                                <div>
                                    <span class="jg-certificate__footer__item__title">Собственник</span>
                                    <div class="jg-certificate__footer__item__sign">
                                        <span>_____________________ / </span>
                                        <span>{{ form.footer.ownerName }}</span>
                                    </div>
                                </div>
                                <span class="jg-certificate__footer__agreement">(Абонент дает согласие использовать персональные данные переданные  
                                с целью реализации государственной политики в сфере защиты персональных данных в соответствии с 
                                Федеральным законом от 27.07.2006г. № 152-ФЗ "Оперсональных данных".)</span>
                            </div>
                            
                            <div class="jg-certificate__footer__item">
                                <div>
                                    <span class="jg-certificate__footer__item__title">Мастер</span>
                                    <div class="jg-certificate__footer__item__sign">
                                        <span>_____________________ / </span>
                                        <span>{{ form.footer.masterName }}</span>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="jg-certificate__footer__item">
                                <div>
                                    <span class="jg-certificate__footer__item__title">Печник трбочист</span>
                                    <div class="jg-certificate__footer__item__sign">
                                        <span>_____________________ / </span>
                                        <span>{{ form.footer.pechnikName }}</span>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="jg-certificate__footer__item">
                                <span class="jg-certificate__footer__item__title">Акт зарегистрирован под № <strong>{{ form.footer.actNumber }}</strong></span>
                            </div>
                            
                            <div class="jg-certificate__footer__item">
                                <span class="jg-certificate__footer__item__title">
                                    Срок действия  акта до&nbsp;&nbsp;</span><span>&#171;&nbsp;&nbsp;{{ form.footer.actExpiringDate.d }}&nbsp;&nbsp;&#187;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ form.footer.actExpiringDate.m }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;20{{ form.footer.actExpiringDate.y }} г.</span>
                            </div>
                        </section>
                    </section>
                </section>

                <GZ-BaseButton class="gz-button_default gz-button_radius-5" @click="printHTML()" value="распечатать" style="margin-top: 40px"/>
            </section>
        </section>
    </gz-auth-view-template>
</template>

<script>
export default {
    name: 'Certificate',

    props: {
        bid: String,
        act: String,
        date: [String, Date]
    },
    data() {
        return {
            form: {
                location: '...',
                date: {
                    d: '...',
                    m: '...',
                    y: '...'
                },
                address: {
                    building: '...',
                    street: '...',
                    count: '...'
                },
                dkCount: '...',
                vkCount: '...',
                propertyNumber: '...',
                dkMm: '...',
                vkMm: '...',
                dkMaterial: '...',
                vkMaterial: '...',
                razdelki: 380,
                razryazhenie: 2,
                checkingDevice: 'AD502694/412',
                tyaga: '...',
                paint: '...',
                removeAirFor2: 80,
                removeAirFor3: 86,
                removeAirFor4: 91.8,
                difmanometr: 'AD502694/412',
                difmanometrTestingDate: '03.02.2020',
                conclusion: {
                    empty2_1: '...',
                    empty2_2: '...',
                    empty2_3: '...',
                    empty3: '...'
                },
                footer: {
                    ownerName: '...',
                    masterName: 'Мусийчук Т.В',
                    pechnikName: '...',
                    actNumber: '...',
                    actExpiringDate: {
                        d: '...',
                        m: '...',
                        y: '...'
                    }
                }
            }
        }
    },
    mounted() {
        if (!this.$route.params.bid) this.$router.go(-1)
        
        this.$store.dispatch('addressesGetBuilding', this.$route.params.bid)
            .then(() => {
                const building = this.$store.getters['addressesBuilding'].attributes
                
                this.form.location = building.city
                
                this.form.date.d = new Date(this.date).getDate()
                if (new Date(this.date).getUTCMonth() + 1 < 10) {
                    let m = new Date(this.date).getUTCMonth() + 1
                    this.form.date.m = '0' + m.toString()
                } else {
                    this.form.date.m = new Date(this.date).getUTCMonth() + 1
                }
                this.form.date.y = new Date(this.date).getUTCFullYear()

                this.form.address.building = building.number
                this.form.address.street = building.street
            })
        
        this.$axios({
            method: 'GET',
            url: '/property/count',
            params: {
                buildingIdList: JSON.stringify([this.$route.params.bid])
            }
        })
        .then(result => {
            this.form.address.count = result.data[0].count
        })
        .catch(err => {
            console.log(err)
        })
        
        this.$axios({
            method: 'GET',
            url: 'report',
            params: {
                bid: this.$route.params.bid,
                date: this.date,
                status: 'PASSED'
            }
        })
        .then(({data}) => {
            const report = data.data.attributes
            this.form.dkCount = data.data.attributes.propertyNumber.length
            this.form.vkCount = data.data.attributes.propertyNumber.length
            let properties = data.data.attributes.propertyNumber.filter(item => item !== '')
            this.form.propertyNumber = properties.join(', ')
            
            let dkSize = data.data.attributes.dkSize.filter(item => item !== '')
            let vkSize = data.data.attributes.vkSize.filter(item => item !== '')
            this.form.dkMm = dkSize.join(', ')
            this.form.vkMm = vkSize.join(', ')
            
            let constr = data.data.attributes.constr.filter(item => item !== '')
            let constrMapped = [] 
            constr.forEach(item => {
                this.$store.getters['filtersBuildingMaterial'].forEach(material => {
                    if (material.value === item) constrMapped.push(material.name)
                })
            })
            this.form.dkMaterial = constrMapped.join(', ')
            this.form.vkMaterial = constrMapped.join(', ')

            this.form.footer.actNumber = this.act
        })
        .catch(err => {
            console.log(err)
        })
    },
    methods: {
        printHTML() {
            const cssFile = require('@/assets/styles/certificate.css')
            const printContents = this.$refs.document.innerHTML
            const a = window.open('')
            a.document.write('<html>') 
            a.document.write(`<head><style>.jg-certificate__container{display:flex;margin-top:10px}.jg-certificate,.jg-certificate__form{height:800px;overflow:auto;max-width:400px;box-sizing:border-box;padding:20px 20px 0 0}.jg-certificate{box-sizing:border-box;padding:20px 40px;max-width:600px;background-color:#fff}.jg-certificate__header{text-align:center;margin-bottom:30px}.jg-certificate__title{margin-bottom:10px;font-size:1.2rem;font-weight:700}.jg-certificate__subtitle{font-weight:700}.jg-certificate__subheader{display:flex;justify-content:space-between;font-size:.9rem;margin-bottom:20px}.jg-certificate__content p{font-size:.9rem;line-height:1.1rem}.jg-certificate__content__address{margin-top:10px;margin-bottom:20px}.jg-certificate__content__address__item{display:flex;justify-content:space-between;margin-bottom:10px;font-size:.9rem}.jg-certificate__content__address__item span{display:block}.jg-certificate__content__address__item div{width:100%;box-sizing:border-box;padding:0 0 3px 5px;margin:0 3px;border-bottom:1px solid #333}.jg-certificate__content__address__item div span{font-size:.9rem;font-weight:700}.jg-certificate__content__title{font-size:.9rem;font-weight:700;text-transform:uppercase;text-align:center;margin-bottom:10px}.jg-certificate__content__item{margin-bottom:15px}.jg-certificate__content__item p{margin-bottom:5px}.jg-certificate__footer{margin-top:40px}.jg-certificate__footer__item{margin-bottom:20px}.jg-certificate__footer__item>div{display:flex}.jg-certificate__footer__item__title{font-weight:700;font-size:1rem}.jg-certificate__footer__item__sign span:last-child{font-weight:700;font-size:1rem}.jg-certificate__footer__agreement{font-size:.8rem}</style></head><body>`) 
            a.document.write(printContents) 
            a.document.write('</body></html>') 
            a.print() 
            a.close() 
        }
    }
}
</script>